import { render, staticRenderFns } from "./SelectMethodParasite.vue?vue&type=template&id=146edc10&scoped=true"
import script from "./SelectMethodParasite.vue?vue&type=script&lang=js"
export * from "./SelectMethodParasite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146edc10",
  null
  
)

export default component.exports